import React from "react";
import { Modal, Table } from "antd";
import moment from "moment";
import { FormatNumber } from "../../../ValueObjects";

export default function modalDetalhesRetencaoNfi({ exibirModal, fecharModal, item }) {

    return (
        <Modal centered 
            title={`Retenções: ${item.pro_descricao}`}
            open={exibirModal}
            onCancel={fecharModal}
            width='60%'
            maskClosable={false}
            footer={null}
        >
            <div>
                <Table 
                    columns={[
                        {
                            title: 'Retenção',
                            align: 'left',
                            width: 170,
                            render: ({ tar_descricao }) => (
                                <div>
                                    <b>{tar_descricao}</b>
                                </div>
                            )
                        },
                        {
                            title: 'Base Cálculo',
                            align: 'right',
                            width: 100,
                            render: ({ nfr_basecalculo }) => (
                                <div>
                                    <b>{FormatNumber(nfr_basecalculo, true)}</b>
                                </div>
                            )
                        },
                        {
                            title: 'Aliquota %',
                            align: 'right',
                            width: 100,
                            render: ({ nfr_percentual }) => (
                                <div>
                                    <b>{FormatNumber(nfr_percentual, true)}</b>
                                </div>
                            )
                        },
                        {
                            title: 'Valor',
                            align: 'right',
                            width: 100,
                            render: ({ nfr_valor }) => (
                                <div>
                                    <b>{FormatNumber(nfr_valor, true)}</b>
                                </div>
                            )
                        },
                    ]}
                    dataSource={item.itemRetencao}
                    pagination={false}
                />
            </div>
        </Modal>
    )
}